module.exports = __webpack_public_path__ + "img/rank_1.b5cefba7.png";